export default "__VITE_ASSET__DWbQYG$F__"